import { makeStyles } from "@fluentui/react-components";
import { CheckmarkCircle16Filled } from "@fluentui/react-icons";
import Form from "../../components/contactForm/Form";
import { dolphinTokens } from "../../utils/Theme";

interface IChallengesProps {
    title: string;
    subtitle: string;
    bullets: string[];
}

const useStyles = makeStyles({
    section: {
        position: "relative",
        overflow: "hidden",
        backgroundColor: dolphinTokens.colorDarkBlue,
        backgroundImage: `radial-gradient(ellipse 60% 80% at 85% 10%, ${dolphinTokens.colorLightBlue40}, transparent 65%)`,
        // Extra bottom padding leaves room for the wave that rises into the Why choose us band.
        padding: "clamp(56px, 8vw, 96px) clamp(20px, 4vw, 40px) clamp(88px, 10vw, 128px)",
    },
    inner: {
        position: "relative",
        zIndex: 1,
        maxWidth: "1180px",
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: "48px",
        "@media (min-width: 900px)": {
            gridTemplateColumns: "1fr 1fr",
            alignItems: "center",
        },
    },
    heading: {
        fontSize: "clamp(26px, 3vw, 38px)",
        fontWeight: 700,
        letterSpacing: "-0.02em",
        lineHeight: 1.2,
        color: "#ffffff",
        margin: "0 0 24px",
    },
    bulletList: {
        display: "flex",
        flexDirection: "column",
        rowGap: "14px",
        listStyleType: "none",
        padding: 0,
        margin: "0 0 28px",
    },
    bulletItem: {
        display: "flex",
        alignItems: "flex-start",
        columnGap: "12px",
    },
    bulletIcon: {
        flexShrink: 0,
        width: "24px",
        height: "24px",
        marginTop: "2px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: dolphinTokens.colorLightBlue40,
        color: dolphinTokens.colorMintGreen,
    },
    bulletText: {
        fontSize: "15px",
        lineHeight: 1.55,
        color: "rgba(255, 255, 255, 0.85)",
    },
    subtitle: {
        fontSize: "16px",
        lineHeight: 1.7,
        color: "rgba(255, 255, 255, 0.68)",
        maxWidth: "46ch",
        margin: 0,
    },
});

export default function Challenges(props: IChallengesProps) {
    const { title, subtitle, bullets } = props;
    const styles = useStyles();

    return (
        <section className={styles.section}>
            <div className={styles.inner}>
                <div>
                    <h2 className={styles.heading}>{title}</h2>

                    {Array.isArray(bullets) && bullets.length > 0 && (
                        <ul className={styles.bulletList}>
                            {bullets.map((bullet) => (
                                <li key={bullet} className={styles.bulletItem}>
                                    <span className={styles.bulletIcon}>
                                        <CheckmarkCircle16Filled />
                                    </span>
                                    <span className={styles.bulletText}>{bullet}</span>
                                </li>
                            ))}
                        </ul>
                    )}

                    <p className={styles.subtitle}>{subtitle}</p>
                </div>

                {/* Form draws its own card (wave header, white surface, shadow) */}
                <Form />
            </div>
        </section>
    );
}